import { render, staticRenderFns } from "./CrmAnalyticsSales.vue?vue&type=template&id=6630d06e"
import script from "./CrmAnalyticsSales.vue?vue&type=script&lang=js"
export * from "./CrmAnalyticsSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports